import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { Map } from 'leaflet';
import { AnchorButton, Button } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import './map.scss';

type Props = {
  defaultZoom: number;
  center: L.LatLng;
  zoomInLocarion?: { latitude: number, longitude: number, zoom: number};
};

const MapControl = ({ defaultZoom, center, zoomInLocarion }: Props) => {
  const map: Map = useMap();

  useEffect(() => {
    if (!zoomInLocarion){
      return;
    }
    map.flyTo({ lat: zoomInLocarion.latitude, lng: zoomInLocarion.longitude }, zoomInLocarion.zoom);
  }, [zoomInLocarion])

  const handleHomeBtn = (): void => {
    map.flyTo(center, defaultZoom);
  };

  const handleBackBtn = (): void => {
    console.log('Coming Soon');
  };

  const handleLayersBtn = (): void => {
    console.log('Coming Soon');
  };

  const handleZoomIn = (): void => {
    map.zoomIn();
  };

  const handleZoomOut = (): void => {
    map.zoomOut();
  };

  return (
    <div>
      <div className="leaflet-top leaflet-left">
        <div className="leaflet-control">
          <div className="general-control-container">
            <AnchorButton icon="home" onClick={handleHomeBtn} />
            {/* TODO: hidden in network topology version 1. re-enable next versions
            <Tooltip2 content="Please upgrade the license to have full access">
              <AnchorButton
                title="Back"
                icon="circle-arrow-left"
                onClick={handleBackBtn}
                disabled
              />
            </Tooltip2>
            <Tooltip2 content="Please upgrade the license to have full access">
              <AnchorButton title="Layers" icon="layers" onClick={handleLayersBtn} disabled />
            </Tooltip2>
            */}
          </div>
        </div>
      </div>

      <div className="leaflet-bottom leaflet-right">
        <div className="leaflet-control">
          <div className="zoom-control-container">
            <Button title="Zoom in" icon="zoom-in" onClick={handleZoomIn} />
            <Button title="Zoom out" icon="zoom-out" onClick={handleZoomOut} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapControl;
